import { Button, type ButtonProps } from '@chakra-ui/react'
import { cx } from '@chakra-ui/utils'
import { ContentfulLivePreview } from '@contentful/live-preview'
import useNavigationActions from '~/hooks/useNavigationActions'
import { type INavigationElement } from '~/types/generated/contentful'

import { IReducedNavigationElement } from '../../../types/reducedTypes'
import ContentfulImage from '../ContentfulImage/ContentfulImage'

export default function ContentfulImageButton({
  componentData,
  overrideValues,
  buttonProps,
  fieldId,
}: {
  componentData: INavigationElement | IReducedNavigationElement
  buttonProps?: ButtonProps
  overrideValues?: {
    width?: number
    height?: number
  }
  fieldId: string
}) {
  const action = useNavigationActions(componentData.fields)

  return (
    <Button
      className={cx(
        'contentful-image-button',
        componentData.fields.htmlClasses,
      )}
      variant="image"
      {...buttonProps}
      {...action}
      {...ContentfulLivePreview.getProps({
        entryId: componentData.sys.id,
        fieldId: fieldId,
      })}
      aria-label={componentData.fields.ariaLabel}
      title={componentData.fields.titleAttribute}
    >
      {componentData.fields.image && (
        <ContentfulImage
          image={componentData.fields.image}
          overrideValues={overrideValues}
          style={{
            objectFit: 'contain',
            maxHeight: 'inherit',
          }}
        />
      )}
    </Button>
  )
}
